import { toPath } from 'lodash-es'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isFirstIn(obj: any, name: string): boolean {
  const path = toPath(name)
  let p = 0

  while (obj && p < path.length) {
    if (path[p] === Object.keys(obj)[0]) {
      // eslint-disable-next-line no-param-reassign, no-plusplus
      obj = obj[path[p++]]
    } else {
      return false
    }
  }

  return true
}
